// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Br3nY","colBig":"styles_colBig__3DVEN","colSmall":"styles_colSmall__OtJF0"};